// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 350 ? "72a30a16" : chunkId) + "." + {"350":"ca99c602bd87fcd5","424":"9f9a5837bc414505","442":"5e7ff442e42400c9"}[chunkId] + ".js";
};